export default __webpack_public_path__ + "static/marketplace-fraud-prevention-img-2-c13381fceb32a5779bc4f459d3c04dc7.png";